import rules from "./rulesReducers";

export default rules;
